import React, { useState } from "react";
import Container from "../ui/Container";
import Card from "../ui/Card";
import { ChevronDown } from "lucide-react";

function QA({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <Card className="p-0 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
      >
        <div className="text-sm font-semibold text-white">{q}</div>
        <ChevronDown className={`h-5 w-5 text-white/60 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-6 pb-6 text-sm leading-6 text-white/65">{a}</div>}
    </Card>
  );
}

export default function WebHostingFAQ() {
  const items = [
    { q: "Do you support WordPress?", a: "Yes — WordPress runs great on standard web hosting plans. If you need heavy performance or custom caching, ask support." },
    { q: "Is email included?", a: "Some plans include email by default. If you prefer external email (Google Workspace, etc.), you can keep it separate." },
    { q: "Do you provide SSL?", a: "Yes, free SSL is included." },
    { q: "How do backups work?", a: "Daily backups are included on all plans. Higher tiers can include additional snapshots." },
    { q: "Can I upgrade later?", a: "Yes — upgrading is straightforward. If your site outgrows shared hosting, we’ll recommend a dedicated server." },
  ];

  return (
    <section className="bg-[#070A0F] py-20">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">FAQ</div>
          <h2 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl">
            Web hosting questions<span className="text-cyan-300">.</span>
          </h2>
        </div>

        <div className="mt-14 mx-auto max-w-3xl space-y-4">
          {items.map((it) => (
            <QA key={it.q} q={it.q} a={it.a} />
          ))}
        </div>
      </Container>
    </section>
  );
}
